/**
 * FHIR constants for persisted addendum DocumentReferences.
 *
 * Addendums use the same Unify document-type and document-category coding
 * systems as admin notes, discharge summaries, and clinical documents
 * (see rbac-pilot-seed.ts). The codes below are specific to addendums.
 */

// ---------------------------------------------------------------------------
// Coding systems (shared with other document types)
// ---------------------------------------------------------------------------

export const DOC_TYPE_SYSTEM = 'https://unify.health/fhir/document-type';
export const DOC_CAT_SYSTEM = 'https://unify.health/fhir/document-category';

// ---------------------------------------------------------------------------
// Addendum-specific codes
// ---------------------------------------------------------------------------

export const ADDENDUM_TYPE_CODE = 'progress-note-addendum';
export const ADDENDUM_TYPE_DISPLAY = 'Progress Note Addendum';

export const ADDENDUM_CATEGORY_CODE = 'addendum';
export const ADDENDUM_CATEGORY_DISPLAY = 'Addendum';

/** Fully-formed CodeableConcept for `DocumentReference.type`. */
export const ADDENDUM_TYPE_CODING = {
  coding: [
    {
      system: DOC_TYPE_SYSTEM as string,
      code: ADDENDUM_TYPE_CODE as string,
      display: ADDENDUM_TYPE_DISPLAY as string,
    },
  ],
};

/** Fully-formed CodeableConcept for `DocumentReference.category`. */
export const ADDENDUM_CATEGORY_CODING = {
  coding: [
    {
      system: DOC_CAT_SYSTEM as string,
      code: ADDENDUM_CATEGORY_CODE as string,
      display: ADDENDUM_CATEGORY_DISPLAY as string,
    },
  ],
};

// ---------------------------------------------------------------------------
// Structured payload stored in attachment.data (base64 JSON)
// ---------------------------------------------------------------------------

export const ADDENDUM_ATTACHMENT_CONTENT_TYPE = 'application/json';
